import React from 'react';

const TripAirplane = ({
  width = 32,
  height = 37,
  fill = '#663C00',
  className = '',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 36.5706"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M32 24.7527V23.2796L28.2415 19.8969V17.3876C28.2415 16.9824 27.9101 16.651 27.5049 16.651C27.0997 16.651 26.7683 16.9824 26.7683 17.3876V18.571L23.035 15.211V13.0956C23.035 12.6903 22.7036 12.359 22.2984 12.359C21.8932 12.359 21.5618 12.6903 21.5618 13.0956V13.8854L18.4921 11.1228C18.3382 5.29124 17.4606 0 16 0C14.5394 0 13.6618 5.29124 13.5079 11.1228L10.4382 13.8854V13.0956C10.4382 12.6903 10.1068 12.359 9.7016 12.359C9.29639 12.359 8.965 12.6903 8.965 13.0956V15.211L5.23169 18.571V17.3876C5.23169 16.9824 4.9003 16.651 4.49509 16.651C4.08987 16.651 3.75848 16.9824 3.75848 17.3876V19.8969L0 23.2796V24.7527L13.6707 18.602C14.023 24.8274 14.7298 31.1527 14.7298 31.1527L10.0569 35.3176L10.184 36.3588L15.2886 35.3176L15.9996 36.5706L16.7106 35.3176L21.8152 36.3588L21.9423 35.3176L17.2693 31.1527C17.2693 31.1527 17.9761 24.8274 18.3285 18.602L32 24.7527Z"
      fill={fill}
    />
  </svg>
);

export default TripAirplane;
